module.exports = __webpack_public_path__ + "static/media/jss-bootcamp.d95758af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jss-bootcamp.jpg
// module id = 1019
// module chunks = 0